/**
 * Utility function to scroll to a hash anchor on the page
 * @param {string} hash - The hash string (e.g., '#tour-operator-services')
 * @param {number} offset - Optional offset from top (default: 100)
 * @param {number} retries - Number of retries if element not found (default: 5)
 */
export const scrollToHash = (hash, offset = 100, retries = 5) => {
  if (!hash) return;
  
  // Remove the # if present
  const id = hash.startsWith('#') ? hash.substring(1) : hash;
  
  const attemptScroll = (attempt = 0) => {
    const element = document.getElementById(id);
    if (element) {
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    } else if (attempt < retries) {
      // Retry after a short delay if element not found yet
      setTimeout(() => attemptScroll(attempt + 1), 200);
    }
  };
  
  // Start attempting to scroll
  setTimeout(() => attemptScroll(), 100);
};

/**
 * Hook to handle hash scrolling on page load
 * Should be used in page components that have hash anchors
 */
export const useHashScroll = () => {
  const { useEffect } = require('react');
  const { useLocation } = require('@/compat/react-router-dom');
  
  const location = useLocation();
  
  useEffect(() => {
    if (location.hash) {
      scrollToHash(location.hash, 100);
    }
  }, [location]);
};
